import { BroadcastMessage } from '@crealogix-map/core';
import { BrowserModule } from './BrowserModule';

export class ShowPdfMessage extends BroadcastMessage {
  constructor(public url: string, public payload: string) {
    super();
  }

  readonly tag = BrowserModule.showPdfMessage;
}


// WEBPACK FOOTER //
// /Users/zasa/map/map-core-git/~/tslint-loader??ref--0-1!./src/Browser/ShowPdfMessage.ts